import { useTranslation } from 'react-i18next';
import { formatTimestamp } from '../date';

/**
 * Similar to `formatTimestamp` but reactive to language changes.
 * Should be preferred over `formatTimestamp` when possible.
 */
export function useDateFormatter() {
  const {
    i18n: { language },
  } = useTranslation();

  return {
    formatDate: (
      inputDate: Date | string | number,
      options: Intl.DateTimeFormatOptions = {
        dateStyle: 'medium',
      },
    ) => formatTimestamp(inputDate, language, options),
  };
}
